import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { has } from 'lodash';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Enums } from '../../../../../../../configs/Enums';
import { BrigadesService } from '../../brigades.service';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-create-new-brigade-modal',
  templateUrl: './create-new-brigade-modal.component.html',
  styleUrls: ['./create-new-brigade-modal.component.scss'],
  standalone: false,
})
export class CreateNewBrigadeModalComponent implements OnInit {
  public errorMessage;
  public user;
  public sector;
  public brigadeName = '';
  public brigadeHeadNewSelected = null;
  public brigadeHeadListInBrigade = [];
  public createBrigadeLoading;
  public errorMessageCode = Enums.errorCodesMaps['BACKEND_ERROR'];
  public createType;
  public currentBrigade;

  constructor(
    public activeModal: NgbActiveModal,
    private brigadesService: BrigadesService
  ) {}

  ngOnInit() {
    if (this.createType === 1) {
      this.getNewBrigadeName();
    }

    if (this.createType === 2) {
      this.brigadeHeadListInBrigade = this.brigadeHeadListInBrigade.map((worker) => {
        worker.full_name = worker.employee.full_name;
        return worker;
      });
    }
  }

  private getNewBrigadeName() {
    this.createBrigadeLoading = true;
    this.brigadesService
      .getBrigadeName({
        sector_id: this.sector.sector_id,
        u_id: this.user.u_id,
      })
      .subscribe(
        (response) => {
          this.brigadeName = response['data'].brigade_name;
          this.createBrigadeLoading = false;
        },
        (error) => {
          this.errorMessage = Enums.errorCodes[Enums.errorCodesMaps['BACKEND_ERROR']];
          this.createBrigadeLoading = false;
        }
      );
  }

  public onChangeSelectedNewBrigadeHead(selected) {
    this.brigadeHeadNewSelected = selected;
  }

  public checkDisabled() {
    switch (this.createType) {
      case 1:
        return !this.brigadeName;
      case 2:
        return !this.brigadeHeadNewSelected;
      default:
        break;
    }
  }

  public onCreateBrigade() {
    switch (this.createType) {
      case 1:
        this.submitCreateBrigade({
          brigade_name: this.brigadeName,
          head: this.user.u_id,
          new_head: null,
          sector_id: +this.sector.sector_id,
        });
        break;
      case 2:
        this.submitCreateBrigade({
          new_head: this.brigadeHeadNewSelected.u_id,
          head: this.user.u_id,
          brigade_name: null,
          sector_id: +this.sector.sector_id,
        });
        break;
      default:
        break;
    }
  }

  public submitCreateBrigade(data) {
    this.createBrigadeLoading = true;
    this.brigadesService.createBrigade(data).subscribe(
      (response) => {
        this.createBrigadeLoading = false;
        this.activeModal.close();
      },
      (error) => {
        if (has(error, 'error.metadata.code') && error.error.metadata.code === 100022) {
          this.errorMessage = 'Бригада с таким названием уже существует';
        } else {
          this.errorMessage = Enums.errorCodes[Enums.errorCodesMaps['BACKEND_ERROR']];
        }
        this.createBrigadeLoading = false;
      }
    );
  }
}
